import {
  Map as ImmutableMap,
} from 'immutable';

function generateDefaultInitialVoltranState() {
  return {
    fragmentsMap: ImmutableMap(),
    isLoading: false,
  };
}

function voltranReducer(state = generateDefaultInitialVoltranState(),
                        action) {
  let newState;

  switch (action.type) {
    case 'GET_FRAGMENTS': {
      newState = {
        ...state,
        isLoading: true
      };
      break;
    }
    case 'GET_FRAGMENTS_FULFILLED': {
      newState = {
        ...state,
        isLoading: false,
        fragmentsMap: action.payload.response.reduce((total, current) => {
          if (current?.result?.data) {
            return total.set(current.result.data.id.toString(), current.result.data);
          }
          return total;
        }, state.fragmentsMap),
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default voltranReducer;
export {
  generateDefaultInitialVoltranState,
};
